import { TESTIMONIALS } from "@/lib/site";
import { Quotes } from "@phosphor-icons/react";

export default function Testimonials() {
  const loop = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section className="bg-sa-ink text-sa-bg overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="max-w-2xl">
          <div className="overline text-sa-accent">Word of mouth</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight mt-4 text-sa-bg">
            What guests <em className="italic font-light">tell their friends.</em>
          </h2>
        </div>
      </div>
      <div className="relative pb-24 md:pb-32 [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex gap-6 marquee-track w-max">
          {loop.map((t, idx) => (
            <figure
              key={`${t.name}-${idx}`}
              className="w-[360px] md:w-[440px] shrink-0 bg-sa-ink2/30 border border-sa-bg/10 rounded-2xl p-8"
              data-testid={`testimonial-${idx}`}
            >
              <Quotes size={28} weight="duotone" className="text-sa-accent" />
              <blockquote className="mt-4 text-sa-bg/90 text-lg leading-relaxed font-serif italic">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 text-sm text-sa-bg/70">
                <span className="text-sa-bg">{t.name}</span> · {t.from}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
